module.exports = __webpack_public_path__ + "0a4cfbe40b635b5ecc9243071d45c75b.png";